// Every top-level content YAML already carries its own `head.slug` — this globs
// all of them so a new page is always covered without a manual registry update
// (the previous hand-maintained list silently missed 7 pages after Feature 13's
// nav restructure). Collection content (news/resources/training/our-work items)
// is reviewed per-item via CmsEditButton instead — see CmsStatus.vue's other groups.
const pageModules = import.meta.glob('/src/content/*.yml', { eager: true })

// Friendly display labels for known pages; anything missing here falls back to
// a title-cased version of its filename, so a new page is still labelled
// sensibly even before someone adds it here.
const LABEL_OVERRIDES = {
  'home': 'Home',
  'about': 'About Us',
  'the-academy': 'The Academy',
  'our-work': 'Our Work landing',
  'training': 'Training landing',
  'our-approach': 'Our Approach',
  'what-we-do': 'What We Do',
  'resources-and-training': 'Resources and Training landing',
  'contact': 'Contact',
  'contact-thankyou': 'Contact — Thank You',
  'stay-informed-thankyou': 'Stay Informed — Thank You',
  'donate': 'Donate',
}

function labelFor(key) {
  return LABEL_OVERRIDES[key] || key.split('-').map(w => w[0].toUpperCase() + w.slice(1)).join(' ')
}

// `route` maps each page's live URL to its content file, so App.vue can look up
// the right CmsReviewButton target from the current route alone — no per-view wiring.
export const REVIEWABLE_PAGES = Object.entries(pageModules)
  .map(([path, mod]) => {
    const slug = mod.default?.head?.slug
    if (!slug) return null
    const key = path.replace('/src/content/', '').replace('.yml', '')
    return { path, label: labelFor(key), route: slug }
  })
  .filter(Boolean)
  .sort((a, b) => a.label.localeCompare(b.label))
